<template>
  <div>
    <!-- Sección de likes -->
    <v-tooltip left :color="isLiked ? '#ffffff00' : '#8e84c0'" v-if="!editor">
      <template v-slot:activator="{ on, attrs }">
        <div class="item-section" v-bind="attrs" v-on="on">
          <v-chip
            color="purple lighten-5"
            text-color="purple darken-2"
            small
          >
            <v-icon
              small
              :color="isLiked ? 'red accent-4' : 'purple darken-2'"
              @click="likeSite"
              :class="{ 'left': likes >= 100 }"
            >
              mdi-heart
            </v-icon>
            <span v-if="likes >= 100">{{ likes.toLocaleString('es-CO') }}</span>
          </v-chip>
        </div>
      </template>
      <span v-if="!isLiked">Me gusta</span>
      <span v-else :style="'color : #ffffff00'">Me gusta</span>
    </v-tooltip>

    <!-- Botón de seguir -->
    <v-tooltip right color="#8e84c0" v-if="!editor && !isOwner">
      <template v-slot:activator="{ on, attrs }">
        <div v-if="!editor" class="follow-button" v-bind="attrs" v-on="on" @click="followHarmony" :class="{ 'button-active': isFollowed }">
          <v-icon v-if="!isFollowed" class="margins-icon" color="#7b1fa2" size="18">mdi-account</v-icon>
          <v-icon v-else class="margins-icon icon" color="#7b1fa2" size="18">mdi-account-check</v-icon>
        </div>
      </template>
      <span v-if="!isFollowed">Seguir</span>
      <span v-else>Dejar de seguir</span>
    </v-tooltip>
  </div>
</template>

<script>
import axios from '@/axios.js';

export default {
  name: 'HarmonyInteractions',
  props: {
    harmonyId: {
      type: Number,
      required: true
    },
    initialLikes: {
      type: Number,
      default: 0
    },
    initialIsLiked: {
      type: Boolean,
      default: false
    },
    initialIsFollowed: {
      type: Boolean,
      default: false
    },
    editor: {
      type: Boolean,
      default: false
    },
    isOwner: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isLiked: this.initialIsLiked,
      isFollowed: this.initialIsFollowed,
      likes: this.initialLikes
    }
  },
  methods: {
    async likeSite() {
      const user = JSON.parse(localStorage.getItem('user'));
      if (user) {
        this.isLiked = !this.isLiked;
        if (this.isLiked) {
          this.likes = this.likes + 1;
        } else {
          this.likes = this.likes - 1;
        }
        try {
          await axios.post('/like-site', { site_id: this.harmonyId });
        } catch (error) {
          if (error.response && error.response.status === 400) {
            console.log(error.response.data.message);
          }
        }
      } else {
        this.$emit('show-login', 'like');
      }
    },
    
    async followHarmony() {
      const user = JSON.parse(localStorage.getItem('user'));
      if (user) {
        try {
          this.isFollowed = !this.isFollowed;
          await axios.post('/follow-site', { site_id: this.harmonyId });
        } catch (error) {
          if (error.response && error.response.status === 400) {
            console.log(error.response.data.message);
          }
        }
      } else {
        this.$emit('show-login', 'follow');
      }
    }
  },
  watch: {
    initialIsLiked(newVal) {
      this.isLiked = newVal;
    },
    initialIsFollowed(newVal) {
      this.isFollowed = newVal;
    },
    initialLikes(newVal) {
      this.likes = newVal;
    }
  }
}
</script>

<style scoped>
.item-section {
  font-size: 20px;
  width: fit-content;
  margin-left: 4px;
}

.follow-button {
  position: fixed;

  top: 58px;
  left: 12px;
  z-index: 90;
  background: #ffffff;
  border-radius: 8px;
  cursor: pointer;
  transition: 0.5s;
}

.button-active {
  background-color: #f1be2f !important;
}

.icon {
  padding: 5px;
  font-size: 1.2rem;
  transition: transform 0.3s ease;
  color: #fff !important;
}

.margins-icon{
  padding: 6px;
}
</style>